import { Component, OnInit, ViewContainerRef, OnDestroy, AfterViewChecked, ChangeDetectorRef, effect, inject, input, output } from '@angular/core';
import { PageLink } from '@shared/models/page-link/page-link.class';
import { StorageService, SharedChangesService, FeatureFlagService } from '@shared/services';
import { FEATURES_FLAGS } from '@shared/constants/features-flag.constant';
import { DialogsService } from '@shared/services/dialogs/dialogs.service';
import { TranslateService } from '@shared/services/translate';
import { Router, NavigationEnd } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { CommonUtilities } from '@shared/models/common/common-utilities.class';
import { INavSubRoute } from '@shared/models/page-link/page-link.interface';
import { SIDEBAR_NAV_TREE } from '@shared/models/navigation/sidebar-nav.config';
import { NavListComponent } from '../../../../shared/components/v2/nav-list/nav-list.component';

@Component({
    selector: 'shopbox-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [NavListComponent]
})
export class ListComponent implements OnInit, OnDestroy, AfterViewChecked {
  private ngUnsubscribe = new Subject<void>();

  minNav = input(false);
  activeProgress = input(false);

  navLinks: PageLink[] = SIDEBAR_NAV_TREE.map((entry) => new PageLink({
    uid: entry.uid,
    route: entry.route,
    name: entry.name,
    originalName: entry.originalName,
    icon: '',
    color: entry.color,
    disabled: entry.disabled,
    active: entry.active,
    divider: false,
    type: entry.type,
    backgroundColor: entry.backgroundColor,
    visible: entry.visible,
    clickable: true,
    skuCode: entry.skuCode,
    iconKey: entry.route,
    group: entry.group,
    children: entry.children.map((c) => ({
      ...c,
      intercomTarget: c.route ? `${c.route.replace(/\//g, '-')}-navigation` : null,
    })),
    expanded: false,
    intercomTarget: entry.route ? `${entry.route.replace(/\//g, '-')}-navigation` : null,
  }));

  // ─── Moved to src/app/shared/models/navigation/sidebar-nav.config.ts ─────
  // The inline PageLink definitions below are kept for reference only.
  // navLinks is now initialised from SIDEBAR_NAV_TREE imported above.
  //
  // navLinks: PageLink[] = [
  //   new PageLink({
  //     uid: 0,
  //     route: 'create-account',
  //     name: 'CREATE_COMPANY',
  //     color: '',
  //     originalName: 'create company',
  //     active: true,
  //     disabled: false,
  //     divider: false,
  //     type: 0,
  //     icon: 'account_circle',
  //     backgroundColor: '#0E9E73',
  //     visible: false,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 1,
  //     route: 'dashboard',
  //     name: 'DASHBOARD',
  //     originalName: 'dashboard',
  //     icon: 'dashboard',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 2,
  //     route: 'sales-reports',
  //     name: 'SALES_REPORTS',
  //     originalName: 'reports',
  //     icon: 'assignment',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 3,
  //     route: 'staff-management',
  //     name: 'STAFF_MANAGEMENT',
  //     originalName: 'staff',
  //     icon: 'group',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 4,
  //     route: 'loyalty-club',
  //     name: 'LOYALTY_CLUB',
  //     originalName: 'customers',
  //     icon: 'loyalty',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 5,
  //     route: 'product-catalog',
  //     name: 'PRODUCTS_CATALOGUE',
  //     originalName: 'products',
  //     icon: 'list',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   // new PageLink({
  //   //   uid: 6,
  //   //   route: 'counter-screen',
  //   //   name: 'COUNTER_SCREEN',
  //   //   originalName: 'counter screen',
  //   //   icon: 'view_comfy',
  //   //   color: '',
  //   //   disabled: false,
  //   //   active: false,
  //   //   divider: false,
  //   //   type: 0,
  //   //   visible: true,
  //   //   clickable: true,
  //   //   skuCode: null
  //   // }),
  //   new PageLink({
  //     uid: 7,
  //     route: 'inventory',
  //     name: 'INVENTORY',
  //     originalName: 'inventory',
  //     icon: 'storage',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: true,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: 'SB40'
  //   }),
  //   new PageLink({
  //     uid: 8,
  //     route: 'store-settings',
  //     name: 'STORE_SETTINGS',
  //     originalName: 'store',
  //     icon: 'store',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   // new PageLink({
  //   //   uid: 14,
  //   //   route: 'pos-customer-display',
  //   //   name: 'POS_CUSTOMER_DISPLAY',
  //   //   originalName: 'posCustomerDisplay',
  //   //   icon: 'view_comfy',
  //   //   color: '',
  //   //   disabled: false,
  //   //   active: false,
  //   //   divider: false,
  //   //   type: 0,
  //   //   visible: true,
  //   //   clickable: true,
  //   //   skuCode: null
  //   // }),
  //   new PageLink({
  //     uid: 9,
  //     route: 'integrations',
  //     name: 'INTEGRATIONS',
  //     originalName: 'integrations',
  //     icon: 'link',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: true,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null,
  //   }),
  //   new PageLink({
  //     uid: 10,
  //     route: 'shopbox-support',
  //     name: 'HELP',
  //     originalName: 'shopboxSupport',
  //     icon: 'support',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 11,
  //     route: 'account-settings',
  //     name: 'ACCOUNT_SETTINGS',
  //     originalName: 'accountSettings',
  //     icon: 'account_circle',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 12,
  //     route: 'developers',
  //     name: 'DEVELOPERS',
  //     originalName: 'developers',
  //     icon: 'terminal-svg',
  //     color: '',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 0,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   }),
  //   new PageLink({
  //     uid: 13,
  //     route: 'logout',
  //     name: 'FORM.ACTIONS.LOGOUT',
  //     originalName: 'logout',
  //     icon: 'input',
  //     color: '#ff6e00',
  //     disabled: false,
  //     active: false,
  //     divider: false,
  //     type: 1,
  //     visible: true,
  //     clickable: true,
  //     skuCode: null
  //   })
  // ];
  // ─────────────────────────────────────────────────────────────────────────

  getActiveLinkName = output<string>();
  setNativeApp = input(false);

  private readonly _featureFlags = inject(FeatureFlagService);

  private readonly _nativeAppEffect = effect(() => {
    if (this.setNativeApp()) {
      const removedUIDS = [4, 5, 6, 7, 8];
      this.navLinks.forEach((el) => {
        if (removedUIDS.includes(el.uid)) {
          el.disabled = true;
        }
      });
    }
  });

  /**
   * Patches the visibility of the loyalty club sub-routes based on feature flags.
   * @description
   * This effect is used to patch the visibility of the loyalty club sub-routes based on feature flags.
   * It is used to hide the customers tab if the allow_table_overview_orders feature flag is enabled.
   * @example
   * {
   *   path: 'loyalty-club/customers',
   *   canActivate: [featureFlagGuard],
   *   data: {
   *     featureFlag: FEATURES_FLAGS.allow_table_overview_orders,
   * @private
   * @memberof ListComponent
   */
  // private readonly _featureFlagEffect = effect(() => {
  //   const flags = this._featureFlags.flags();
  //   this._patchFeatureFlagVisibility(flags);
  //   this._changeDetectRef.markForCheck();
  // });

  baseURL: string = '';
  currentSelectedIndex: number;

  firstTime: boolean = false;
  trialEnded: boolean = false;
  isTrialClient: boolean = false;
  confirmed: boolean = false;
  subscriptionEnabled: boolean = false;
  isPartnerAndPaymentByCardAndPaymentNotExist: boolean = false;
  isFutureSubscription: boolean = false;

  urlChanges: UntypedFormControl = new UntypedFormControl();
  currentChild: Element | null = null;

  constructor(
    private storageSrv: StorageService,
    private viewContainer: ViewContainerRef,
    private _changeDetectRef: ChangeDetectorRef,
    private dialogSrv: DialogsService,
    private router: Router,
    private shared: SharedChangesService,
    public translate: TranslateService,
  ) {
    this.detectRouterChanges();
    this.detectURLChanges();
  }

  detectURLChanges() {

    this.urlChanges.valueChanges.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((res) => {
      if (res !== -1) {
        this.setAccessModules();
        this.setActiveIndex(res);
        const urlLocation = new URL(location.href);
        const hashedUrl = urlLocation.hash;
        this.syncSubRoutesState(hashedUrl);
        if (this.subscriptionEnabled) {
          if (hashedUrl.includes('create-account')) {
            const id = this.navLinks[0].uid;
            const founded = this.searchForClientAndConfirmed(hashedUrl);
            if (!founded) {
              this.setActiveSingleLink(id, true, true, false, false);
            }
            this.toggleCreationLink(true);
          }
        }
        this.emitActivePageByRouteName();
      }
    });

    this.shared.currentClientChange.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(() => {
      this.patchConditionalSubRouteVisibility();
      const urlLocation = new URL(location.href);
      const hashedUrl = urlLocation.hash;
      const index = this.getURLIndex(hashedUrl);
      this.urlChanges.setValue(index);
      this._changeDetectRef.markForCheck();
    });
  }

  /**
   * Mirrors visibility rules from feature modules (e.g. account-settings subscription tabs,
   * store clip cards, sales-reports children vs shopbox-reports tabs). Call after building
   * sidebar children and when the current client changes.
   */
  private patchConditionalSubRouteVisibility(): void {
    this.patchAccountSettingsSubRouteVisibility();
    this.patchStoreSettingsSubRouteVisibility();
    this.patchSalesReportsSubRouteVisibility();
  }

  private patchAccountSettingsSubRouteVisibility(): void {
    const newSubRaw = this.storageSrv.getNewSubscriptionPlan();
    const newSubData = Array.isArray(newSubRaw) ? newSubRaw : [];
    const subscriptionEnable = Boolean(CommonUtilities.GetSubscriptionFeature());
    const client = CommonUtilities.GetCurrentClient();
    const isTrialAndPartner = Boolean(client?.['isTrial'] && client?.['isPartner']);
    const managedByPartner = Boolean(this.storageSrv.getIsManagedByPartner());

    const accountLink = this.navLinks.find((l) => l.route === 'account-settings');
    if (!accountLink?.children?.length) {
      return;
    }

    accountLink.children.forEach((child) => {
      if (child.route === 'account-settings/chargebee-settings') {
        child.visible = subscriptionEnable && newSubData.length > 0 && !managedByPartner;
      } else if (child.route === 'account-settings/plan-settings') {
        child.visible = subscriptionEnable && !isTrialAndPartner && newSubData.length === 0;
      }
    });
  }

  private patchStoreSettingsSubRouteVisibility(): void {
    const storeLink = this.navLinks.find((l) => l.route === 'store-settings');
    if (!storeLink?.children?.length) {
      return;
    }

    storeLink.children.forEach((child) => {
      if (child.route === 'store-settings/clip-cards') {
        child.visible = true;
        child.disabled = !Boolean(CommonUtilities.GetClipCardFeature());
      }
    });
  }

  /** Matches shopbox-reports (ReportsComponent): isApp → cashier only; gift tab uses getGiftFeatureTab rules. */
  private patchSalesReportsSubRouteVisibility(): void {
    const salesReportsLink = this.navLinks.find((l) => l.route === 'sales-reports');
    if (!salesReportsLink?.children?.length) {
      return;
    }

    const isApp = CommonUtilities.getIsApp() === 'true';
    const isNativeApp = CommonUtilities.getIsNativeApp();
    const giftSubVisible =
      !isApp &&
      !Boolean(isNativeApp) &&
      Boolean(CommonUtilities.GetGiftCardFeature());

    salesReportsLink.children.forEach((child) => {
      if (isApp) {
        child.visible = child.route === 'sales-reports/end-of-day-report';
        return;
      }
      if (child.route === 'sales-reports/gift-card-vouchers-report') {
        child.visible = giftSubVisible;
        return;
      }
      child.visible = true;
    });
  }

  searchForClientAndConfirmed(url: string): boolean {
    const arry1 = url.split('?');
    let result = false;
    if (arry1 && arry1[1]) {
      const str = arry1[1];
    if (str && str.includes('confirmed=true') && str.includes('client=')) {
      result = true;
    }
    }
    return result;
  }

  ngOnInit() {
    // @TODO: Find better solution
    // Q: how do U learn coding in a single night ?
    // A: Pack a laptop and travel to the north pole in the beginning of winter.
    //    You'll have a 6 months of a night to learn coding.
    //    once there - really just Google it.
    //    there are tons of excellent tutorials on the web.
    const urlLocation = new URL(location.href);
    const hashedUrl = urlLocation.hash;
    const index = this.getURLIndex(hashedUrl);
    this.patchConditionalSubRouteVisibility();
    this.syncSubRoutesState(hashedUrl);
    this.urlChanges.setValue(index);
  }

  ngAfterViewChecked() {
    this.setFocusOnActiveElement();
  }

  setAccessModules() {
    if (this.storageSrv.getCurrentClient()) {
      const modulesAccess: string[] = this.storageSrv.getModulesAccess();
      const subscriptionStatus: boolean = this.storageSrv.getSubscriptionPlanStatus();
      this.subscriptionEnabled = this.storageSrv.getCurrentClient()['subscriptionEnable'];
      if (this.subscriptionEnabled) {
        this.navLinks.forEach(element => {
          let found = false;
          let i = -1;
          modulesAccess.forEach((element2, index) => {
            if (element.skuCode && (element.skuCode.toLowerCase() === element2.toLowerCase())) {
              found = true;
              i = index;
            }
          });
          if (found) {
            element.disabled = false;
            element.clickable = true;
            this.setSettingsToggle(element, true);
          } else if (element.skuCode) {
            element.disable = false;
            element.clickable = true;
            this.setSettingsToggle(element, false);
          } else {
            element.disabled = false;
            element.clickable = true;
            if (element.name === 'INTEGRATIONS') this.setSettingsToggle(element, true);
          }
        });
      }
    }
  }

  setFocusOnActiveElement() {
    const navList = document.querySelector('#navList');
    if (navList) {
      const children = navList.children;
      if (children && children.length > 0) {
        for(let i =0; i < children.length; i++) {
          if (this.currentChild !== children[i] && children[i].getAttribute('data-focus') === 'true') {
            this.currentChild = children[i];
            setTimeout(() => {
              children[i].scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            });
          }
        }
      }
    }
  }

  setSettingsToggle(element: PageLink, val: boolean) {
    const currentId: number = Number(this.storageSrv.getClientUID());
    if (currentId && this.storageSrv.getCurrentClient()) {
      this.subscriptionEnabled = Boolean(this.storageSrv.getCurrentClient()['subscriptionEnable']);
      if (this.subscriptionEnabled) {
        switch (element.originalName) {
          case 'customers':
            this.storageSrv.setClientsSettingsValue('customerModuleOn', val, currentId);
            break;
          case 'integrations':
            this.storageSrv.setClientsSettingsValue('integrationModuleOn', val, currentId);
            break;
          case 'inventory':
            this.storageSrv.setClientsSettingsValue('inventoryModuleOn', val, currentId);
            break;
        }
      }
    } else {
      this.storageSrv.deleteClientsSettings();
    }
  }

  setActiveIndex(index: number) {

    const newSubData = this.storageSrv.getNewSubscriptionPlan();

    this.currentSelectedIndex = index;

    if(!Array.isArray(newSubData) || !newSubData.length) {
      this.setActiveLinkIndex(index);
    }
    // this.setActiveLinkIndex(index);
  }

  setActiveLinkIndex(index: number) {
    const id = this.navLinks[index].uid;
    this.firstTime = this.storageSrv.getFirstTimeCreation();
    this.trialEnded = this.storageSrv.getCurrentClientTrialEnded();
    this.isTrialClient = this.storageSrv.getIsTrialClient();
    this.confirmed = this.storageSrv.getConfirmation();
    this.isPartnerAndPaymentByCardAndPaymentNotExist = this.isPartnerClient() && this.isCardPaymentType() && !this.isPaid();
    this.isFutureSubscription = this.storageSrv.getIsSubscriptionInFuture();
    this.subscriptionEnabled = this.storageSrv.getCurrentClient() ? Boolean(this.storageSrv.getCurrentClient()['subscriptionEnable']) : true;
    if (this.subscriptionEnabled) {
      if (this.firstTime) {
        if (this.trialEnded && this.isTrialClient) {
          this.setActiveSingleLink(id, true, true, false, false);
          this.toggleCreationLink(false);
        } else if (!this.isTrialClient) {
          this.setActiveSingleLink(id, true, true, false, false);
        } else {
          this.setActiveLink(id, true, true, false, false);
        }
      } else {
        if (this.isSettingToSingleLink()) {
          this.setActiveSingleLink(id, true, true, false, false);
        } else {
          this.setActiveLink(id, true, true, false, false);
        }
        if (!this.confirmed) {
          this.toggleCreationLink(false);
        } else {
          this.toggleCreationLink(true);
        }
      }
    } else {
      this.setActiveLink(id, true, true, false, false);
      this.toggleCreationLink(false);
    }
  }

  isSettingToSingleLink(): boolean {
    return (
      (this.storageSrv.getAccount() && !this.storageSrv.getClientUID()) ||
      (this.trialEnded && this.isTrialClient) ||
      (this.isPartnerAndPaymentByCardAndPaymentNotExist || (this.isFutureSubscription && this.isCardPaymentType() && !this.isPaid()))
    );
  }

  getURLIndex(url: string): number {
    return this.navLinks.findIndex(elem => url.toLowerCase().includes(elem.route.toLowerCase()));
  }

  detectRouterChanges() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      takeUntil(this.ngUnsubscribe)
    ).subscribe((res: NavigationEnd) => {
      const URL = res.urlAfterRedirects;
      const index = this.getURLIndex(URL);
      this.urlChanges.setValue(index);
      this.syncSubRoutesState(URL);
      if (index !== -1) {
        this.checkOnChargeebeSub(index);
        const name  = this.navLinks[index].name;
        this.emitActivePageByRouteName();
      }
    });
  }

  checkOnChargeebeSub(index: number) {
    const id = this.navLinks[index].uid;

    const newSubData = this.storageSrv.getNewSubscriptionPlan();
    if(Array.isArray(newSubData) && newSubData.length) {
      this.setActiveSingleLink(id, true, true, true, true);
      this.setActiveLink(id, true, true, true, true);
      this.activeCreateCompanyLink();
    }
  }

  onMainItemClick(link: PageLink) {
    if (!link) {
      return;
    }
    const hasChildren = Array.isArray(link.children) && link.children.length > 0;
    if (hasChildren) {
      if (link.disabled && !link.active) {
        return;
      }
      if (this.minNav()) {
        this.expandDrawerFromCollapsed();
        this.collapseOtherMenus(link.uid);
        link.expanded = true;
        this._changeDetectRef.markForCheck();
        return;
      }
      const nextExpanded = !link.expanded;
      this.collapseOtherMenus(link.uid);
      link.expanded = nextExpanded;
      return;
    }
    if (link.disabled) {
      return;
    }
    if (this.activeProgress()) {
      return;
    }
    if (link.type === 1 || link.route === 'logout') {
      this.logout();
      return;
    }
    this.collapseAllExpandedMenus();
    this.router.navigateByUrl(link.route);
  }

  onChevronClick(link: PageLink) {
    if (!link || !link.children || !link.children.length) {
      return;
    }
    if (link.disabled && !link.active) {
      return;
    }
    const nextExpanded = !link.expanded;
    this.collapseOtherMenus(link.uid);
    link.expanded = nextExpanded;
  }

  onSubItemClick(event: { parent: PageLink; child: INavSubRoute }) {
    if (!event || !event.child || !event.parent || this.activeProgress()) {
      return;
    }
    if (event.child.disabled) {
      return;
    }
    this.collapseOtherMenus(event.parent.uid);
    event.parent.expanded = true;
    this.router.navigateByUrl(event.child.route);
  }

  syncSubRoutesState(url: string) {
    const currentUrl = (url || '').toLowerCase();
    this.navLinks.forEach((link) => {
      const children = link.children || [];
      if (!children.length) {
        return;
      }
      let hasActiveChild = false;
      children.forEach((child) => {
        child.active = currentUrl.includes(child.route.toLowerCase());
        if (child.active) {
          hasActiveChild = true;
        }
      });
      if (hasActiveChild) {
        this.collapseOtherMenus(link.uid);
        link.active = true;
        link.expanded = true;
      } else {
        // URL is not under this parent: always collapse, even if link.active was
        // left true (otherwise multiple sections can stay expanded).
        link.expanded = false;
      }
    });
  }

  private collapseOtherMenus(activeUid: number) {
    this.navLinks.forEach((link) => {
      if (link.uid !== activeUid) {
        link.expanded = false;
      }
    });
  }

  /** Desktop narrow sidebar (72px): opening a section widens the drawer like the header toggle. */
  private expandDrawerFromCollapsed(): void {
    if (this.storageSrv.getTokenTemp()) {
      this.storageSrv.setDrawerStatusTemp(true);
    } else {
      this.storageSrv.setDrawerStatus(true);
    }
  }

  private collapseAllExpandedMenus(): void {
    this.navLinks.forEach((link) => {
      link.expanded = false;
    });
  }

  logout() {

    const title = this.translate.instant('LOGOUT_QUESTION');
    const message = this.translate.instant('LOGOUT_CONTENT');
    const cancelBtn = this.translate.instant('FORM.ACTIONS.CANCEL');
    const logoutBtn = this.translate.instant('FORM.ACTIONS.LOGOUT');
    this.dialogSrv.confirm(message, this.viewContainer, cancelBtn, logoutBtn, title).subscribe(
      (res: boolean) => {
      if (res === true) {
        this.navLinks.forEach(ele => ele.activation = false);
        this.storageSrv.logout();
        this.router.navigateByUrl('login');
        this.emitActivePageByRouteName();
        this._changeDetectRef.markForCheck();
        // if (this.channel) {
        //   this.channel.postMessage('logout');
        // }
      }
    });
  }

  emitActivePageByRouteName() {

    const index = this.navLinks.findIndex(el => el.active);
    if (index !== -1) {
      this.getActiveLinkName.emit(this.navLinks[index].name);
    } else {
      this.getActiveLinkName.emit('');
    }
  }

  toggleCreationLink(val: boolean) {
    this.navLinks[0].visible = val;
  }

  setActiveSingleLink(id: number, active: boolean, visible: boolean, clickable: boolean, disabled: boolean) {

    this.navLinks.forEach((el) => { el.clickable = false; el.disabled = true; el.active = false; el.visible = true; el.backgroundColor = null; });
    const index = this.navLinks.findIndex(element => element.uid === id);
    if (index !== -1) {
      this.navLinks[index].visible = visible;
      this.navLinks[index].disabled = disabled;
      this.navLinks[index].active = active;
      this.navLinks[index].clickable = clickable;
      this.navLinks[index].backgroundColor =  '#0E9E73';
    }
    this.activeLogoutLink();
  }

  setActiveLink(id: number, active: boolean, visible: boolean, clickable: boolean, disabled: boolean) {

    this.navLinks.forEach((el) => { el.clickable = true; el.disabled = false; el.active = false; el.visible = true; el.backgroundColor = null; });
    const index = this.navLinks.findIndex(element => element.uid === id);
    if (index !== -1) {
      this.navLinks[index].visible = visible;
      this.navLinks[index].disabled = disabled;
      this.navLinks[index].active = active;
      this.navLinks[index].clickable = clickable;
    }
    this.activeLogoutLink();
  }

  activeLogoutLink() {
    const logoutLink = this.navLinks.find(l => l.route === 'logout');
    if (!logoutLink) { return; }
    logoutLink.visible = true;
    logoutLink.disabled = false;
    logoutLink.clickable = true;
    logoutLink.active = false;
    logoutLink.activation = false;
  }

  activeCreateCompanyLink() {
    const createLink = this.navLinks.find(l => l.route === 'create-account');
    if (!createLink) { return; }
    createLink.visible = false;
    createLink.disabled = true;
    createLink.clickable = false;
    createLink.active = false;
    createLink.activation = false;
  }

  isPartnerClient(): boolean {
    return this.storageSrv.getIsClientPartner() === true;
  }

  isCardPaymentType(): boolean {
    return this.storageSrv.getIsClientPartnerCard() === true;
  }

  isPaid(): boolean {
    return Boolean(this.storageSrv.getPaymentInfo());
  }

  /**
   * Patches the visibility of the loyalty club sub-routes based on feature flags.
   * @description
   * This method is used to patch the visibility of the loyalty club sub-routes based on feature flags.
   * It is used to hide the customers tab if the allow_table_overview_orders feature flag is enabled.
   * @example
   * {
   *   path: 'loyalty-club/customers',
   *   canActivate: [featureFlagGuard],
   *   data: {
   *     featureFlag: FEATURES_FLAGS.allow_table_overview_orders,
   *   } satisfies FeatureFlagGuardData,
   * }
   * @param {Partial<Record<string, boolean>>} flags - The feature flags.
   * @returns {void}
   */
  // private _patchFeatureFlagVisibility(flags: Partial<Record<string, boolean>>): void {
  //   const loyaltyLink = this.navLinks.find((l) => l.route === 'loyalty-club');
  //   if (!loyaltyLink?.children?.length) {
  //     return;
  //   }
  //   loyaltyLink.children.forEach((child) => {
  //     if (child.route === 'loyalty-club/customers') {
  //       child.visible = !(flags[FEATURES_FLAGS.allow_table_overview_orders] ?? false);
  //     }
  //   });
  // }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
